if (!customElements.get('image-slider')) {
    class ImageSlider extends HTMLElement {
        constructor() {
            super();
            this.elements = {
                element: this
            }
            this.dots = this.querySelectorAll('.shopthelook-dot');
            this.containers = this.querySelectorAll('.shopthelook-box-container');
            this.init();

            if(this.dots.length == 0) return;
            this.dots.forEach((dot) => dot.addEventListener('click', this.onLookbookClick.bind(this)));
            this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
            document.body.addEventListener('click', this.onBodyClickEvent);
        }

        connectedCallback() {
            if (Shopify.designMode) {
                this.onShopifySectionLoad = this.onSectionLoad.bind(this);
                this.onShopifySectionSelect = this.onSectionSelect.bind(this);
                this.onShopifySectionDeselect = this.onSectionDeselect.bind(this);
                document.addEventListener('shopify:section:load', this.onShopifySectionLoad);
                document.addEventListener('shopify:section:select', this.onShopifySectionSelect);
                document.addEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
            }
        }

        disconnectedCallback() {
            if (Shopify.designMode) {
                document.removeEventListener('shopify:section:load', this.onShopifySectionLoad);
                document.removeEventListener('shopify:section:select', this.onShopifySectionSelect);
                document.removeEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
            }
        }

        onSectionLoad(event) {
            filterShopifyEvent(event, this, () => this.initSlider.bind(this));
        }

        onSectionSelect(event) {
            filterShopifyEvent(event, this, this.initSlider.bind(this));
        }

        onSectionDeselect(event) {
            filterShopifyEvent(event, this, this.initSlider.bind(this));
        }

        init() {
            if (Shopify && Shopify.designMode) this.initSlider();
            setTimeout(() => this.initSlider());
        }

        onBodyClick() {
            if (!this.contains(event.target)) {
                this.dots.forEach((element) => element.classList.remove('active'));
                this.containers.forEach(element => {
                    element.classList.remove('active');
                    element.classList.add('hidden');
                });
            }
        }

        initSlider() {
            var swiper = new Swiper(this.elements.element, {
                spaceBetween: 80,
                autoplay: {
                    delay: 10000,
                },
                loop: true,
                navigation: {
                    nextEl: ".swiper-button-next-image",
                    prevEl: ".swiper-button-prev-image"
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
            });

            this.elements.element.addEventListener('mouseenter', () => swiper.autoplay.stop());
            this.elements.element.addEventListener('mouseleave', () => swiper.autoplay.start());
        }

        onLookbookClick(event) {
            event.preventDefault();
            event.stopPropagation();
            var _target = event.currentTarget.getAttribute('data-product-target');
            var _isActive = !event.currentTarget.classList.contains('active');
            this.dots.forEach((element) => element.classList.remove('active'));
            this.containers.forEach((element) => {
                element.classList.remove('active');
                element.classList.add('hidden');
            });
            if (_isActive) {
                event.currentTarget.classList.toggle('active');
                this.querySelector(`[id="${_target}"]`).classList.toggle('hidden');
                this.querySelector(`[id="${_target}"]`).classList.toggle('active');
            }
        }
    }
    
    customElements.define('image-slider', ImageSlider);
}